import {Component, EventEmitter, Input, Output} from "@angular/core";
import {FilterCriteria} from "../api/filter.criteria";
import {FilterCriteriaChangeEvent} from "../api/filter-criteria-change-event";


@Component({
    selector: 'mvs-filter-component-base',
    template: '',
    standalone: false
})
export class MvsFilterComponentBase {

    @Input() filterCriteria: FilterCriteria[] | undefined;
    @Input() readOnly: boolean = false;

    @Output() onChange: EventEmitter<FilterCriteriaChangeEvent> =
        new EventEmitter<FilterCriteriaChangeEvent>();

}